import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { ScrollToTop } from "@/components/ScrollToTop";
import { MainLayout } from "@/components/layout/MainLayout";
import Landing from "./pages/Landing";
import Introduccion from "./pages/Introduccion";
import Eleccion from "./pages/Eleccion";
import NotFound from "./pages/NotFound";
import EleccionLayout from "@/components/eleccion/EleccionLayout";
import RespiracionStep from "@/components/eleccion/steps/RespiracionStep";
import RespiracionResultadosStep from "@/components/eleccion/steps/RespiracionResultadosStep";
import MedicionStep from "@/components/eleccion/steps/MedicionStep";
import MedicionResultadoStep from "@/components/eleccion/steps/MedicionResultadoStep";
import FelicitacionesStep from "@/components/eleccion/steps/FelicitacionesStep";
import ProductosStep from "@/components/eleccion/steps/ProductosStep";
import PlanSeleccionStep from "@/components/eleccion/steps/PlanSeleccionStep";
import PagoStep from "@/components/eleccion/steps/PagoStep";
import VariantTester from "@/components/testing/VariantTester";
import ShopifyProductTester from "@/components/testing/ShopifyProductTester";
import SnapshotView from "./pages/SnapshotView";
import QuoteView from "./pages/QuoteView";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AppProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Landing />} />
              <Route path="introduccion" element={<Introduccion />} />
              <Route path="variant-tester" element={<VariantTester />} />
              <Route path="shopify-tester" element={<ShopifyProductTester />} />
              <Route path="snapshot/:snapshotId" element={<SnapshotView />} />
              <Route path=":quoteId" element={<QuoteView />} />
              <Route path="eleccion" element={<Eleccion />} />
              <Route path="eleccion/*" element={<EleccionLayout />}>
                <Route path="respiracion" element={<RespiracionStep />} />
                <Route path="respiracion-resultados" element={<RespiracionResultadosStep />} />
                <Route path="medicion" element={<MedicionStep />} />
                <Route path="medicion-resultado" element={<MedicionResultadoStep />} />
                <Route path="felicitaciones" element={<FelicitacionesStep />} />
                <Route path="productos" element={<ProductosStep />} />
                <Route path="plan-seleccion" element={<PlanSeleccionStep />} />
                <Route path="pago" element={<PagoStep />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
